import { useSelectExpertiseData } from './store/stream/selectors';
import { useContext, useEffect, useMemo, useState } from 'react';
import { ExpertiseResponseDataItem } from 'communication/types/expertise/ExpertiseResponse';
import { buildFiltersFunction } from 'utils/filter/functions/filtersFunction';
import {
    ExpertiseColumn,
    expertiseColumnDefinitions,
} from './ExpertiseColumnDefinitions';
import { useSelectCurrentCurrency } from 'app/store/selectors';
import { useSelectQuickSearchText } from './store/component/selectors';
import buildQuickSearchFunction from 'utils/components/QuickSearch/quickSearchFunction';
import AppContext from 'app/AppContext';
import { FilterState } from 'widgets/store/grid/filters/FilterState';

export const useFilteredExpertiseData = (
    visibleColumns: ExpertiseColumn[] | undefined,
    filters: FilterState<ExpertiseColumn>[] | undefined
) => {
    const data = useSelectExpertiseData();
    const currency = useSelectCurrentCurrency();

    const appContext = useContext(AppContext);
    const quickSearchText = useSelectQuickSearchText();

    const [filteredData, setFilteredData] = useState<
        ExpertiseResponseDataItem[] | undefined
    >();

    const quickSearchFunction = useMemo(
        () =>
            buildQuickSearchFunction(
                expertiseColumnDefinitions,
                quickSearchText,
                visibleColumns ?? [],
                appContext
            ),
        [quickSearchText, visibleColumns, appContext]
    );

    useEffect(() => {
        if (!data) {
            setFilteredData(undefined);
            return;
        }
        const filterFn = buildFiltersFunction(
            expertiseColumnDefinitions,
            filters ?? [],
            currency?.rate ?? 1
        );

        let nextFilteredData = data.filter(filterFn);

        if (quickSearchText) {
            nextFilteredData = nextFilteredData.filter(quickSearchFunction);
        }

        setFilteredData(nextFilteredData);
    }, [data, filters, currency, quickSearchText, quickSearchFunction]);

    return filteredData;
};
